import React from 'react';
import { BaseEdge, EdgeProps, getBezierPath, EdgeLabelRenderer, MarkerType } from '@xyflow/react';

const AnimatedEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
}) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <>
      <svg width="0" height="0">
        <defs>
          <marker
            id="arrowhead"
            markerWidth="16"
            markerHeight="16"
            refX="13"
            refY="8"
            orient="auto"
            markerUnits="userSpaceOnUse"
          >
            <path d="M2,2 L14,8 L2,14 L8,8 L2,2" fill="#007aff" />
          </marker>
        </defs>
      </svg>
      <BaseEdge
        path={edgePath}
        markerEnd={MarkerType.Arrow}
        style={{
          ...style,
          strokeWidth: 2,
          stroke: 'var(--edge-stroke)',
          pointerEvents: 'all',
          cursor: 'pointer',
        }}
        interactionWidth={10}
      />
      <BaseEdge
        path={edgePath}
        markerEnd={MarkerType.Arrow}
        style={{
          ...style,
          strokeWidth: 2,
          stroke: 'url(#animated-edge-gradient)',
          strokeDasharray: 5,
          animation: 'flow 1s linear infinite',
        }}
      />
      {data?.label && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              fontSize: 12,
              pointerEvents: 'all',
            }}
            className="nodrag nopan bg-white px-2 py-1 rounded shadow-md"
          >
            {typeof data.label === 'string' ? data.label : String(data.label)}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

export default AnimatedEdge; 